import Home from '../modules/Home/Home';
import CreateShippingAddress from '../modules/ShippingAddress/CreateShippingAddress';
import TermsAndConditions from '../modules/Home/TermsAndConditions';
import PrivacyPolicy from '../modules/Home/PrivacyPolicy';
import CartItemEdit from '../modules/Cart/CartItemEdit';
import ProductView from '../modules/Products/ProductView';
import Products from '../modules/Products/Products';
import CookiePolicy from '../modules/Home/CookiePolicy';
import ProductVariants from '../modules/Products/ProductVariants';
import Drafts from '../modules/Drafts/Drafts';
import Cart from '../modules/Cart/Cart';
import Checkout from '../modules/Cart/Checkout';
import CartItemUpsell from '../modules/Cart/CartItemUpsell';
import Auth from '../modules/Auth/Auth';
import Registration from '../modules/Auth/Registration';
import Login from '../modules/Auth/Login';
import Orders from '../modules/Account/Orders';
import ShippingAddresses from '../modules/Account/ShippingAddresses';
import Profile from '../modules/Account/Profile';
import OrderThankYou from '../modules/Order/OrderThankYou';
import UpdateShippingAddress from '../modules/ShippingAddress/UpdateShippingAddress';
import AboutUs from '../modules/Home/AboutUs';
import ForgotPassword from '../modules/Auth/ForgotPassword';
import ResetPassword from '../modules/Auth/ResetPassword';
export var routes = [
    {
        path: "/auth/login",
        component: Login,
        layout: 'HeadlessLayout',
    },
    {
        path: "/auth/reset-password",
        component: ResetPassword,
        layout: 'HeadlessLayout',
    },
    {
        path: "/auth/forgot-password",
        component: ForgotPassword,
        layout: 'HeadlessLayout',
    },
    {
        path: "/auth/registration",
        component: Registration,
        layout: 'HeadlessLayout',
    },
    {
        path: "/auth",
        component: Auth,
        layout: 'HeadlessLayout',
    },
    {
        path: "/shipping-addresses/:id/edit",
        component: UpdateShippingAddress,
        guarded: true,
        layout: 'HeadlessLayout',
    },
    {
        path: "/shipping-addresses/create",
        component: CreateShippingAddress,
        guarded: true,
        layout: 'HeadlessLayout',
    },
    {
        path: "/order/:secret/done",
        component: OrderThankYou,
        guarded: true,
    },
    {
        path: "/account/orders",
        component: Orders,
        guarded: true,
    },
    {
        path: "/account/addresses",
        component: ShippingAddresses,
        guarded: true,
    },
    {
        path: "/account/profile",
        component: Profile,
        guarded: true,
    },
    {
        path: "/drafts",
        component: Drafts,
    },
    {
        path: "/cart/checkout",
        component: Checkout,
        guarded: true,
        layout: 'HeadlessLayout',
    },
    {
        path: "/cart",
        component: Cart,
    },
    {
        path: "/cart-items/:id/upsell",
        component: CartItemUpsell,
        layoutParams: {
            disableFooter: true,
            disableMobileNavigation: true,
            modifiers: ['stretch-content'],
        },
    },
    {
        path: "/cart-items/:id",
        component: CartItemEdit,
        layout: 'CartItemEditorLayout',
    },
    {
        path: "/products/:slug/variants",
        component: ProductVariants,
        layout: 'ProductVariantsLayout',
    },
    {
        path: "/products/:slug",
        component: ProductView,
        layout: 'ProductViewLayout',
    },
    {
        path: "/products",
        component: Products,
    },
    {
        path: "route.about_us.slug",
        component: AboutUs,
    },
    {
        path: "route.terms_and_conditions.slug",
        component: TermsAndConditions,
    },
    {
        path: "route.privacy_policy.slug",
        component: PrivacyPolicy,
    },
    {
        path: "route.cookie_policy.slug",
        component: CookiePolicy,
    },
    {
        path: "/",
        component: Home,
        layoutParams: {
            disableHeaderDivider: true,
        },
    },
];
export default routes;
